import { combineReducers } from 'redux';

import auth from 'redux/reducers/_auth'
import sessions from 'redux/reducers/_sessions'
import reports from 'redux/reducers/_reports'
import summons from 'redux/reducers/_summons'
import endusers from 'redux/reducers/_endusers'
import tours from 'redux/reducers/_tours'
import zones from 'redux/reducers/_zones'
import trackers from 'redux/reducers/_trackers'
import panics from 'redux/reducers/_panics'
import web from 'redux/reducers/_web'

export default combineReducers({
    auth,
    sessions,
    reports,
    summons,
    endusers,
    tours,
    web,
    zones,
    trackers,
    panics
});



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js